var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalSetoran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8449 12.6875H8.62489C8.21089 12.6875 7.87489 12.3515 7.87489 11.9375C7.87489 11.5235 8.21089 11.1875 8.62489 11.1875H15.8449C16.2589 11.1875 16.5949 11.5235 16.5949 11.9375C16.5949 12.3515 16.2589 12.6875 15.8449 12.6875ZM15.8449 16.4465H8.62489C8.21089 16.4465 7.87489 16.1105 7.87489 15.6965C7.87489 15.2825 8.21089 14.9465 8.62489 14.9465H15.8449C16.2589 14.9465 16.5949 15.2825 16.5949 15.6965C16.5949 16.1105 16.2589 16.4465 15.8449 16.4465ZM8.62489 7.42651H11.3799C11.7939 7.42651 12.1299 7.76251 12.1299 8.17651C12.1299 8.59051 11.7939 8.92651 11.3799 8.92651H8.62489C8.21089 8.92651 7.87489 8.59051 7.87489 8.17651C7.87489 7.76251 8.21089 7.42651 8.62489 7.42651ZM12.2499 2.24951C5.68489 2.24951 3.35889 4.80151 3.35889 12.0005C3.35889 19.1985 5.68489 21.7505 12.2499 21.7505C18.8139 21.7505 21.1409 19.1985 21.1409 12.0005C21.1409 4.80151 18.8139 2.24951 12.2499 2.24951Z",
    fill: "#0054E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSetoran);
export default __webpack_public_path__ + "static/media/total-setoran.77b949f814d658eeb7af1c008a53f496.svg";
export { ForwardRef as ReactComponent };